import { ErrorsState } from 'components/search/bex/interfaces';

const initialErrorsState: ErrorsState = {
  errors: {},
};

export { initialErrorsState };
